export default {
  quoteSections: [],
  quoteSection: undefined,
};
